import { render, staticRenderFns } from "./CustomFieldCheckboxEditor.vue?vue&type=template&id=8e4b96e2&"
import script from "./CustomFieldCheckboxEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldCheckboxEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports